// FIXME: Make these generic and add the application namespace
// ex: export const SETUP_DATA_KEY = APPLICATION_NAMESPACE + '.rp_sd'
export const SETUP_DATA_KEY = 'rp_sd'
export const JWT_STORAGE_KEY = 'rp_at'
export const SETTINGS_STORAGE_KEY = 'rp_us'
export const ERRORS_STORAGE_KEY = 'rp_err'
export const RESET_PASSWORD_KEY = 'rp_reset'
export const CLUSTER_KEY = 'rp_cluster'
export const CLIENT_ID_KEY = 'rp_client_id'
export const SSO_TOKEN_KEY = 'rp_sso_token'
export const LOGIN_TRACKED = 'login_tracked'
export const LOGIN_FROM_ENTRATA = 'login_from_entrata'
export const FORCE_LOGOUT = 'force_logout'
export const CUSTOM_JWT_STORAGE_KEY = 'rp_custom_at'
export const LANGUAGE_PREFERENCE = 'language_preference'
export const ENABLE_BULK_PAYMENT = 'enable_bulk_payment'
export const RP_PRIVACY_SETTINGS = 'RP_PRIVACY_SETTINGS'
export const SHOW_EMBEDDED_VIEW = 'show_embedded_view'
export const CAPRICON_VENDOR = 'homebody';
export const CAPRICON_CONSUMER = 'api-homebody'
export const COLLEEN_VENDOR = 'colleen'
export const COLLEEN_CONSUMER = 'payments-ai'
export const COLLEEN_PAYMENT_LINK_ID = 'colleen_payment_link_id'
export const COLLEEN_PAYMENT_PAGE_FLAG = 'colleen_payment_page_flag'
export const APP_MODULE = 'app_module'
export const EMBEDDED_VENDOR = 'embedded_vendor'
export const LANGUAGE_SET_FROM_NORMAL_LOGIN = 'language_set_from_normal_login'
export const TP_INVITE_USER = 'inviteUser'
export const OTP_LOGIN = 'otp_login'
export const I18N_MOCK = 'I18N_MOCK'
export const RP_USER_DATA = 'rp_ud'
export const RP_SESSION_COOKIE_DELETED = 'rp_cookie_deleted'
export const RP_SELECTED_LEASE_ID = 'selectedLeaseId'
export const RP_LEASE_ID = 'rp_lid'
export const RP_PROPERTY_ID = 'rp_pid'
export const TP_MODE = 'tp_mode'
export const TP_IS_DARK = 'tp_is_dark'
export const TP_FONT_FAMILY = 'tp_font_family'
export const TP_FONT_SIZE = 'tp_font_size'
export const TP_FONT_WEIGHT = 'tp_font_weight'
export const TP_HIGH_CONTRAST = 'tp_high_contrast'
export const TP_CARD_STYLE = 'tp_card_style'
export const TP_CORNER_RADIUS = 'tp_corner_radius'
export const TP_SIDEBAR_POSITION = 'tp_sidebar_position'
export const TP_ICON_STYLE = 'tp_icon_style'
export const TP_SPACING_DENSITY = 'tp_spacing_density'
export const IS_GENAI_ENABLED = 'is_genai_enabled'
export let IS_COOKIE_FUNCTIONALITY_ENABLED = true 
export const OTP_TIMER_END = 'otp_timer_end'
export const PP_LOGIN_SUCCESS = 'pp_login_success'
export const IS_PUSH_NOTIFICATION_CALLED = 'isPushNotificationCalledFirstTime'
export const ENTRATA_DOMAIN = 'entrata_domain'
export const USER_AUTH = 'user_auth'
export const IS_COLLEEN = 'isColleen'
export const IS_COMPANY_USER_FULL_ACCESS = 'is_company_user_full_access'
export const IS_COMPANY_USER_FULL_ACCESS_TEXT = 'You do not have access to this feature'
export const NON_ADMIN_PERMISSION_TEXT = 'You do not have permission to access this area of Tenant Portal. To get access, please reach out to your TenantPortal Admin.'
export const NO_PERMISSION_TEXT = 'Your user account does not currently have any Permission set to see Tenant Portal functionality. Please reach out to your Tenant Portal Admin to get your necessary permissions.'
export const NO_PERMISSION_TITLE = 'No Permission Available'
export const NO_PAYMENT_ACCESS_TEXT = 'Your user account has limited TenantPortal permissions. Please see the navigation menu for options you are permissioned to see. If you need access to other areas of Tenant Portal, please reach out to your Tenant Portal Admin.'
export const WELCOME_MODAL_SHOWN = 'welcome_modal_shown'

// Insurance-related constants - configured via environment variables
export const INSURANCE_SERVICE_EMAIL = 'service@homebody.com'
export const INSURANCE_REQUEST_SUBJECT = 'Commercial Tenant Insurance Request'
export const INSURANCE_FORM_NAME =  'insurance-request'
export const FORMSUBMIT_BASE_URL =  'https://formsubmit.co/ajax'
export const INSURANCE_SUCCESS_MESSAGE =  'Your business insurance request has been submitted successfully. You will hear back from our team within 1-2 business days.'
export const MESSAGE_AUTO_DISMISS_TIMEOUT = 10000 // 10 seconds
export const INSURANCE_CONTACT_REASON_ID =  1

if (window.location.origin.includes('http://localhost')) {
    IS_COOKIE_FUNCTIONALITY_ENABLED = false
} else if ((/(.global)/.test(window.location.origin))) {
    IS_COOKIE_FUNCTIONALITY_ENABLED = false
} else if(window?.rpSettings?.loginFromExternalClient || window?.rpSettings?.loginFromExternalSource || 
    sessionStorage.getItem(SHOW_EMBEDDED_VIEW)) {
    IS_COOKIE_FUNCTIONALITY_ENABLED = false
}